import { Link } from 'react-router-dom';
import { siteCategories } from '@/mocks/navigation';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="lg:pr-6">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-lg">
                <i className="ri-flashlight-fill" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold">爆料导航网</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-50/70">
              按领域整理信息入口的导航站。把同类型站点集中摆在一起，打开一个分区就能顺着找到更多，不用再自己攒收藏夹。
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-background-50/70">
              <i className="ri-mail-line" aria-hidden="true"></i>
              contact@baoliao-nav.com
            </p>
          </div>

          <nav aria-label="热门分类">
            <h3 className="font-heading text-base font-semibold text-background-50">热门分类</h3>
            <ul className="mt-4 space-y-2.5">
              {siteCategories.slice(0, 5).map((category) => (
                <li key={category.id}>
                  <Link
                    to={`/category/${category.id}`}
                    className="text-sm text-background-50/70 hover:text-accent-300 transition-colors"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="更多分类">
            <h3 className="font-heading text-base font-semibold text-background-50">更多分类</h3>
            <ul className="mt-4 space-y-2.5">
              {siteCategories.slice(5).map((category) => (
                <li key={category.id}>
                  <Link
                    to={`/category/${category.id}`}
                    className="text-sm text-background-50/70 hover:text-accent-300 transition-colors"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="站内导航">
            <h3 className="font-heading text-base font-semibold text-background-50">站内导航</h3>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-50/70 hover:text-accent-300 transition-colors">
                  首页目录
                </Link>
              </li>
              <li>
                <Link to="/#ranking" className="text-sm text-background-50/70 hover:text-accent-300 transition-colors">
                  热门站点榜
                </Link>
              </li>
              <li>
                <Link to="/submit" className="text-sm text-background-50/70 hover:text-accent-300 transition-colors">
                  提交站点收录
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/70 hover:text-accent-300 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-background-50/60">© {year} 爆料导航网 · 分类整理，一站收录</p>
          <p className="text-xs text-background-50/60">
            站内信息均整理自公开渠道，仅供信息检索参考，不构成任何专业建议。
          </p>
        </div>
      </div>
    </footer>
  );
}